import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";

function Content({ children, ...props }) {
  let element = props.obj;
  const isBE = props.catname === "BE";
  const isBF17 = props.catname === "BF17";
  const isUmschreibung = props.catname === "UMSCHREIBUNG";
  const isB197 = props.catname === "B197";
  const isA = props.catname === "A";

  const hasThumb = Boolean(element?.thumb?.data);
  const hasInfo = Boolean(element?.info);
  const hasList = getListEntries(element).length > 0;
  const hasInfoThumb = Boolean(element?.info?.thumb?.data);

  if (!hasThumb) {
    return <NoPhoto element={element} />;
  }

  if (isB197) {
    return <B197 element={element} isBF17={isBF17} />;
  }

  if (hasThumb && !hasInfo) {
    return (
      <>
        {isUmschreibung ? (
          <div>
            <MainThree element={element} />
            <ContentFooter element={element} mt={true} />
          </div>
        ) : (
          <MainOne element={element} isBF17={isBF17} />
        )}
      </>
    );
  }

  if (hasThumb && hasInfo && hasList && hasInfoThumb) {
    return (
      <>
        {element.description1 && element.description2 ? (
          <MainTwo element={element} isBF17={isBF17} />
        ) : (
          <MainOne element={element} isBF17={isBF17} />
        )}

        {children}

        <ContentOne element={element} isBE={isBE} isA={isA} />

        {element.description1 && element.description2 && (
          <ContentFooter element={element} />
        )}
      </>
    );
  }

  return null;
}

export default Content;

function NoPhoto({ element }) {
  return (
    <section className={`layout__color_primary position-relative`}>
      <Container fluid className="layout__main">
        <Row>
          <Col md={12} lg={7} xl={6}>
            <h2
              data-aos="fade-up"
              dangerouslySetInnerHTML={{ __html: element.title }}
            ></h2>
          </Col>
          <Col
            xs={12}
            md={10}
            lg={5}
            xl={5}
            xxl={6}
            className="offset-xl-1 offset-xxl-0 layout_mt__md mt-lg-0"
          >
            <p
              data-aos="fade-up"
              className="layout_text"
              dangerouslySetInnerHTML={{ __html: element.description }}
            ></p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

function MainOne({ element, isBF17 }) {
  return (
    <section className={`layout__color_primary position-relative`}>
      <Container fluid className="layout__main">
        <Row className={`${isBF17 ? "layout_BF17 " : ""}`}>
          <Col md={12} lg={7} xl={6}>
            <Row>
              <Col xs={12} xl={7} xxl={8} className="mb-lg-5 mb-xl-0">
                <h2
                  data-aos="fade-up"
                  dangerouslySetInnerHTML={{ __html: element.title }}
                ></h2>
              </Col>
              <Col
                xs={10}
                sm={8}
                md={6}
                xl={5}
                xxl={4}
                className={`mt-xl-0 ${isBF17 ? "special_mt" : "layout_mt__md "}`}
              >
                <CategoryImage
                  media={element.thumb.data}
                  alt={element.title}
                  className={`autoImg layout_image layout_image__round ${isBF17 ? "layout_image__absolute " : ""}`}
                />
              </Col>
            </Row>
          </Col>
          <Col xs={12} md={10} lg={5} xl={5} className="offset-xl-1">
            {element.description && (
              <p
                className="layout_text"
                data-aos="fade-up"
                dangerouslySetInnerHTML={{ __html: element.description }}
              ></p>
            )}
            {element.intro && (
              <p className="layout_text layout_text__medium" data-aos="fade-up">
                {element.intro}
              </p>
            )}
            {Array.isArray(element.points) && (
              <div className="d-flex flex-column gap-new layout_mt_new">
                {element.points.map((point, index) => {
                  return (
                    <div key={`point_${index}`} className="">
                      <h4
                        className="layout_title layout_title__subitem text-uppercase fw-400 mb-3"
                        data-aos="fade-up"
                      >
                        {point.title}
                      </h4>
                      <p
                        className="layout_text mb-0"
                        data-aos="fade-up"
                        dangerouslySetInnerHTML={{ __html: point.description }}
                      ></p>
                    </div>
                  );
                })}
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </section>
  );
}

function MainTwo({ element, isBF17 }) {
  return (
    <section className={`layout__color_primary position-relative`}>
      <Container fluid className="layout__main">
        <Row>
          <Col md={12} lg={7} xl={6}>
            <Row className="h-100 flex-column justify-content-between">
              <Col xs={12} xl={7} xxl={8} className="mb-lg-5 mb-xl-0">
                <h2
                  data-aos="fade-up"
                  dangerouslySetInnerHTML={{ __html: element.title }}
                ></h2>
              </Col>
              <Col lg={8} xl={5} className="mt-xl-0 d-none d-lg-block">
                <CategoryImage
                  media={element.thumb.data}
                  alt={element.title}
                  className={`autoImg layout_image layout_image__round ${isBF17 ? "layout_image__absolute " : ""}`}
                />
              </Col>
            </Row>
          </Col>
          <Col
            xs={12}
            md={10}
            lg={5}
            xl={5}
            xxl={4}
            className="offset-xl-1 layout_mt__md"
          >
            <p
              className="layout_text"
              data-aos="fade-up"
              dangerouslySetInnerHTML={{ __html: element.description }}
            ></p>
          </Col>
          <Col xs={12} sm={10} md={8} className="layout_mt__md d-lg-none">
            <CategoryImage
              media={element.thumb.data}
              alt={element.title}
              className={`autoImg layout_image layout_image__round ${isBF17 ? "layout_image__absolute " : ""}`}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

function MainThree({ element }) {
  return (
    <section className={`layout__color_primary position-relative`}>
      <Container fluid className="layout__main">
        <Row>
          <Col md={12} lg={7} xl={6}>
            <Row className="h-100 flex-column">
              <Col xs={12} xl={7} xxl={8} className="mb-lg-5 mb-xl-0">
                <h2
                  data-aos="fade-up"
                  dangerouslySetInnerHTML={{ __html: element.title }}
                ></h2>
              </Col>
              <Col
                xs={12}
                sm={10}
                md={8}
                lg={8}
                xl={7}
                className="layout_mt__md layout_mt"
              >
                <CategoryImage
                  media={element.thumb.data}
                  alt={element.title}
                  className="autoImg layout_image layout_image__round"
                />
              </Col>
            </Row>
          </Col>
          <Col xs={12} md={10} lg={5} xl={6} xxl={6}>
            <ListItems
              items={getListEntries(element)}
              listClassName="list list__small"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

function B197({ element, isBF17 }) {
  return (
    <section className={`layout__color_primary position-relative`}>
      <Container fluid className="layout__main">
        <Row>
          <Col md={12} lg={7} xl={6}>
            <Row>
              <Col xs={12} xl={7} xxl={8}>
                <h2
                  data-aos="fade-up"
                  dangerouslySetInnerHTML={{
                    __html:
                      element.title +
                      `
							<svg class="contentSvg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 78 78">
								<defs>
								<clipPath id="clip-thicker">
									<rect width="78" height="78"/>
								</clipPath>
								</defs>
								<g id="thicker" clip-path="url(#clip-thicker)">
								<path id="_" data-name="*" d="M37.5-39.864h-10l.479-20.344L10.588-49.571,5.648-58.25l17.93-9.705L5.648-77.66l4.94-8.678L27.981-75.7,27.5-96.045h10L37.019-75.7,54.412-86.338l4.94,8.678-17.93,9.705,17.93,9.705-4.94,8.678L37.019-60.208Zm-6.925-3h3.853L33.89-65.637,53.336-53.746l1.892-3.325L35.119-67.955,55.229-78.839l-1.892-3.325L33.89-70.272l.536-22.774H30.573l.536,22.774L11.664-82.164,9.771-78.839,29.881-67.955,9.771-57.07l1.892,3.325L31.11-65.637Z" transform="translate(6.352 107.045)" fill="#ad3b37"/>
								</g>
							</svg>
						`,
                  }}
                ></h2>
              </Col>
            </Row>
          </Col>
          <Col
            xs={12}
            md={10}
            lg={5}
            xl={5}
            xxl={4}
            className="offset-xl-1 order-1 order-lg-0"
          >
            <p
              data-aos="fade-up"
              className="layout_text"
              dangerouslySetInnerHTML={{ __html: element.description }}
            ></p>
          </Col>
          <Col
            xs={10}
            sm={8}
            md={6}
            xl={5}
            xxl={3}
            className={`layout_mt layout_mt__md`}
          >
            <CategoryImage
              media={element.thumb.data}
              alt={element.title}
              className={`autoImg layout_image layout_image__round ${isBF17 ? "layout_image__absolute " : ""}`}
            />
          </Col>
          <Col
            xs={12}
            md={10}
            lg={5}
            xl={5}
            className="offset-lg-1 offset-xl-2 offset-xxl-4 layout_mt order-1"
          >
            <ListItems items={getListEntries(element)} />
          </Col>
          <Col
            xs={12}
            md={10}
            lg={5}
            xl={5}
            className="order-1 pe-xl-5 layout_mt mt-lg-0"
          >
            <p
              data-aos="fade-up"
              className="layout_text"
              dangerouslySetInnerHTML={{
                __html:
                  `
						<svg class="contentSvg_min" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 78 78">
							<defs>
							<clipPath id="clip-thicker">
								<rect width="78" height="78"/>
							</clipPath>
							</defs>
							<g id="thicker" clip-path="url(#clip-thicker)">
							<path id="_" data-name="*" d="M37.5-39.864h-10l.479-20.344L10.588-49.571,5.648-58.25l17.93-9.705L5.648-77.66l4.94-8.678L27.981-75.7,27.5-96.045h10L37.019-75.7,54.412-86.338l4.94,8.678-17.93,9.705,17.93,9.705-4.94,8.678L37.019-60.208Zm-6.925-3h3.853L33.89-65.637,53.336-53.746l1.892-3.325L35.119-67.955,55.229-78.839l-1.892-3.325L33.89-70.272l.536-22.774H30.573l.536,22.774L11.664-82.164,9.771-78.839,29.881-67.955,9.771-57.07l1.892,3.325L31.11-65.637Z" transform="translate(6.352 107.045)" fill="#ad3b37"/>
							</g>
						</svg>
					` + element.info.description,
              }}
            ></p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

function ContentOne({ element, isBE, isA }) {
  return (
    <section className={`layout__color_primary position-relative`}>
      <Container fluid className="layout__main">
        <Row className="">
          {isBE ? (
            <Col
              md={12}
              lg={6}
              xl={5}
              className="mb-5 mb-xl-0 offset-lg-1 offset-xl-2  order-1 d-none d-lg-block"
            >
              <CategoryImage
                media={element.info.thumb.data}
                alt={element.title}
                className="autoImg layout_image layout_image__round"
              />
            </Col>
          ) : (
            <Col md={12} lg={7} xl={6} className="mb-5 mb-xl-0">
              <Row
                className={`h-100 flex-column ${!isA && "justify-content-between"}`}
              >
                <Col xs={12} xl={7} xxl={8}>
                  <h2
                    data-aos="fade-up"
                    dangerouslySetInnerHTML={{ __html: element.info.title }}
                  ></h2>
                </Col>
                <Col
                  xs={12}
                  sm={10}
                  md={8}
                  className={isA ? "layout_mt_faq" : "layout_mt"}
                >
                  <CategoryImage
                    media={element.info.thumb.data}
                    alt={element.title}
                    className="autoImg layout_image layout_image__round"
                  />
                </Col>
              </Row>
            </Col>
          )}

          <Col
            xs={12}
            md={10}
            lg={5}
            xl={5}
            className={isBE ? "" : "offset-xl-1"}
          >
            {isBE && (
              <p
                data-aos="fade-up"
                className="layout_text layout_mb__adaptive"
                dangerouslySetInnerHTML={{ __html: element.info.description }}
              ></p>
            )}
            {element.intro && (
              <p className="layout_text layout_text__medium" data-aos="fade-up">
                {element.intro}
              </p>
            )}
            <ListItems
              items={getListEntries(element)}
              listClassName={`list ${isBE ? "list__small" : ""} ${element.intro && "layout_mt_new d-flex flex-column gap-new"}`}
              itemClassName={`list_item d-flex ${isBE ? "align-items-center" : "align-items-start"}`}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

function ContentFooter({ element, mt = false }) {
  return (
    <section className={`layout__color_primary position-relative`}>
      <Container fluid className="layout__main">
        <Row className={` ${mt ? "layout_mt__100_lg" : ""}`}>
          <Col md={12} lg={7} xl={5} className="layout_mb__30 mb-lg-0">
            <p
              data-aos="fade-up"
              className="layout_text"
              dangerouslySetInnerHTML={{ __html: element.description1 }}
            ></p>
          </Col>
          {element.description2 !== null && (
            <Col xs={12} md={10} lg={5} xxl={4} className="offset-xl-2">
              <p
                data-aos="fade-up"
                className="layout_text"
                dangerouslySetInnerHTML={{ __html: element.description2 }}
              ></p>
            </Col>
          )}

          <Col
            xs={12}
            lg={5}
            className={`text-end text-lg-start ${element.description2 !== null ? "offset-lg-7 offset-xl-7" : "offset-xl-2"} `}
          >
            <a
              data-aos="fade-up"
              href="/kontakt"
              className={`btn btn__border btn__border_primary btn__mobile mt-5 ${element.description2 !== null ? "mt-lg-3" : "mt-lg-0"}`}
            >
              KONTAKT
            </a>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

function getMediaUrl(media) {
  const attrs = media?.attributes;

  if (!attrs?.url) {
    return "";
  }

  return attrs.localFile
    ? attrs.url
    : process.env.REACT_APP_BACKEND_URL + attrs.url;
}

function getListEntries(element) {
  if (Array.isArray(element?.list)) {
    return element.list;
  }

  if (Array.isArray(element?.items)) {
    return element.items;
  }

  return [];
}

function CategoryImage({ media, alt, className }) {
  const src = getMediaUrl(media);

  if (!src) {
    return null;
  }

  return <img data-aos="fade-up" src={src} alt={alt} className={className} />;
}

function ListItems({
  items,
  listClassName = "list",
  itemClassName = "list_item d-flex align-items-start",
}) {
  return (
    <ol className={listClassName}>
      {items.map((item, index) => (
        <li
          data-aos="fade-up"
          className={`${itemClassName} ${item.code && "list_item__hascode"} ${item.title && "mb-0 flex-column gap-3"}`}
          key={`list_${index}`}
        >
          {item.code && <span className={`list_item_code`}>{item.code}</span>}
          <div>
            {item.title && (
              <h4 className="layout_title layout_title__subitem text-uppercase fw-400 mb-3">
                {item.title}
              </h4>
            )}
            {item.age && <p className="layout_text fw-600 mb-3">{item.age}</p>}
            <p className="layout_text">{item.description}</p>
          </div>
        </li>
      ))}
    </ol>
  );
}
